/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_ExcelInputs */

const vi_import_excel = /** @type {(inputs: Import_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Excel`)
};

/**

* @param {Import_ExcelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_excel = /** @type {((inputs?: Import_ExcelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_ExcelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_excel(inputs)
});